
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"43.858","height":"21.75"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 526","fill":"#f4313f"}},[_c('path',{attrs:{"data-name":"Path 1097","d":"M13.958.21H7.516v7.522H0v6.448h7.516v7.511h6.442v-7.516h7.516V7.733h-7.516z"}}),_c('path',{attrs:{"data-name":"Path 1098","d":"M31.441 10.838a9.06 9.06 0 0112.232-8.494 10.873 10.873 0 10.186 16.915 9.069 9.069 0 01-12.418-8.421z"}})])])
          )
        }
      }
    